const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6d7731c-f1ff-4387-8ea8-6b5a78e11adf",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.57 6.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.57,1.05V2.29H4V1.05A.65.65,0,0,0,3.36.4.66.66,0,0,0,2.9.59L.59,2.9a.66.66,0,0,0,0,.92L2.9,6.13a.66.66,0,0,0,.92,0A.64.64,0,0,0,4,5.68V4.44h6.56V5.68a.64.64,0,0,0,1.1.45L14,3.82a.64.64,0,0,0,0-.92L11.67.59a.65.65,0,0,0-.91,0A.6.6,0,0,0,10.57,1.05Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 20,
      strokeWidth: "0.800000011920929px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubleArrow);
export default __webpack_public_path__ + "static/media/duble_arrow.f9c52cf6df22d3cfb65c53ccd9b06315.svg";
export { ForwardRef as ReactComponent };